export default "__VITE_ASSET__TOLNG8JY__"